module.exports = __webpack_public_path__ + "img/newsletter-1-dark.74e370cf.svg";